import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import * as selectOperator from '@app/src/views/CipReport/filter/state/operator/selectors';
import * as selectPaymentType from '@app/src/views/CipReport/filter/state/paymentType/selectors';
import * as selectDetail from '@app/src/views/CipReport/report/state/detail/selectors';
import * as selectFilterValues from '@app/src/views/CipReport/report/state/filterValues/selectors';
import * as selectValidationRange from '@app/src/views/CipReport/filter/state/validationDateRange/selectors';
import { registerFilterValues } from '@app/src/views/CipReport/report/state/filterValues/actions';
import { fetchDetail } from '@app/src/views/CipReport/report/state/detail/actions';

const Container = reduxForm({
  form: 'filter',
  enableReinitialize : true,
  onSubmit (fields, dispatch, { url }) {
    dispatch(registerFilterValues(fields));
    dispatch(fetchDetail({ page: 1, ...fields }, url, true));
  }
})(Form);

const selector = formValueSelector('filter');

const mapStateToProps = state => ({
  operators: selectOperator.getOperator(state),
  paymentTypes: selectPaymentType.getPaymentTypes(state),
  items: selectDetail.getItems(state),
  filter: selectFilterValues.getValues(state),
  cip: selector(state, 'cip'),
  documentNumber: selector(state, 'documentNumber'),
  isFetchingDetails: selectDetail.getIsFetching(state),
  detailErrorMessage: selectDetail.getErrorMessage(state),
  startDateErrorMessage: selectValidationRange.getStartDateErrorMessage(state),
  endDateErrorMessage: selectValidationRange.getEndDateErrorMessage(state),
  message: selectOperator.getMessage(state),
  sessionRol: selectOperator.getSessionRol(state),
  initialValues: {
    stateId: state.filterValues.stateId.toString(),
    userId: state.filterValues.userId.toString(),
    dateStart: state.filterValues.dateStart,
    dateEnd: state.filterValues.dateEnd,
    paymentType: state.filterValues.paymentType
  }
});

export const FormContainer = connect(
  mapStateToProps
)(Container);
